import { render, staticRenderFns } from "./toolCom.vue?vue&type=template&id=68670ede&scoped=true&"
import script from "./toolCom.vue?vue&type=script&lang=js&"
export * from "./toolCom.vue?vue&type=script&lang=js&"
import style0 from "./toolCom.vue?vue&type=style&index=0&id=68670ede&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68670ede",
  null
  
)

export default component.exports